export const translation = {
  // Navbar
  nav_spreadsheet: 'Spreadsheet',
  nav_categories: 'Categories',
  nav_guides: 'Guides',
  nav_shipping: 'Shipping',
  nav_qc: 'QC',
  nav_reviews: 'Reviews',
  nav_language: 'Language',
  nav_cta: 'Visit Main Site',
  nav_home: 'Home',
  nav_shopping_guide: 'Shopping Guide',

  // Hero
  hero_eyebrow: 'THE ALLCHINABUY SPREADSHEET RESOURCE HUB',
  hero_title: 'AllChinaBuy Spreadsheet — Find Products, Sellers & Buying Guides',
  hero_desc: 'Looking for an AllChinaBuy spreadsheet? Explore curated product resources, seller information, QC guides, shipping tips, warehouse information and practical buying guides — all organized in one easy-to-use resource hub.',
  hero_cta_primary: 'Explore AllChinaBuy Spreadsheet',
  hero_cta_secondary: 'Browse Buying Guides',
  hero_trust: 'Independent resource · Updated regularly · Multilingual',
  hero_search_placeholder: 'Search AllChinaBuy spreadsheet, products, sellers or guides...',

  // Trust Bar
  trust_spreadsheet: 'Spreadsheet Resources',
  trust_spreadsheet_desc: 'Organized product and seller information.',
  trust_guides: 'Buying Guides',
  trust_guides_desc: 'Practical guides for new and experienced users.',
  trust_qc: 'QC & Safety',
  trust_qc_desc: 'Understand quality checks and common risks.',
  trust_shipping: 'Shipping Resources',
  trust_shipping_desc: 'Learn about shipping methods, costs and considerations.',

  // What Is Section
  what_is_title: 'What Is an AllChinaBuy Spreadsheet?',
  what_is_desc: 'An AllChinaBuy spreadsheet is a convenient way to organize product, seller and shopping information in one place. Our resource hub helps you discover useful AllChinaBuy spreadsheet resources, understand product categories, compare options and learn how the buying process works.',
  what_is_cta: 'Explore the Spreadsheet Hub →',

  // Categories Section
  categories_title: 'Browse Popular Categories',
  categories_cta: 'Explore All Categories →',

  // Popular Searches
  popular_title: 'Popular AllChinaBuy Searches',
  popular_spreadsheet: 'AllChinaBuy Spreadsheet',
  popular_review: 'AllChinaBuy Review',
  popular_shipping: 'AllChinaBuy Shipping Cost',
  popular_coupon: 'AllChinaBuy Coupon',
  popular_discount: 'AllChinaBuy Discount Code',
  popular_warehouse: 'AllChinaBuy Warehouse',
  popular_legit: 'AllChinaBuy Legit',
  popular_qc: 'AllChinaBuy QC',

  // Buying Guides
  guides_title: 'AllChinaBuy Buying Guides',
  guides_desc: 'Learn how to find products, evaluate sellers, understand QC information, estimate shipping costs and avoid common mistakes with practical AllChinaBuy guides.',
  guides_cta: 'View All Guides →',
  pillar_title: 'AllChinaBuy Pillar Articles',
  pillar_desc: 'In-depth original guides covering spreadsheets, reviews, shipping, warehouse, QC, sellers, and comparisons to help you shop smarter.',
  guide_1_title: 'Complete Spreadsheet Guide',
  guide_1_desc: 'Master the AllChinaBuy spreadsheet with our comprehensive guide.',
  guide_2_title: 'Shipping Cost Calculator',
  guide_2_desc: 'Estimate shipping costs before you buy with our detailed breakdown.',
  guide_3_title: 'QC Photo Checklist',
  guide_3_desc: 'Learn what to look for in quality control photos every time.',
  guide_4_title: 'Seller Verification Guide',
  guide_4_desc: 'How to identify reliable sellers and avoid common scams.',
  guide_5_title: 'Warehouse Process Explained',
  guide_5_desc: 'Understand how the AllChinaBuy warehouse handles your items.',
  guide_6_title: 'Beginner Buying Strategy',
  guide_6_desc: 'Essential tips for first-time buyers using AllChinaBuy.',

  // Comparison
  comparison_title: 'AllChinaBuy Compared With Other Shopping Platforms',
  comparison_cta: 'See All Comparisons →',
  vs_superbuy: 'AllChinaBuy vs Superbuy',
  vs_cssbuy: 'AllChinaBuy vs CSSBuy',
  vs_sugargoo: 'AllChinaBuy vs Sugargoo',
  vs_kakobuy: 'AllChinaBuy vs Kakobuy',

  // Safety Section
  safety_title: 'AllChinaBuy Safety Center',
  safety_desc: 'Before purchasing, learn how to evaluate sellers, protect your account, recognize suspicious links, understand payment risks and make better-informed purchasing decisions.',
  safety_cta: 'Visit Safety Center →',

  // Review Section
  review_title: 'Is AllChinaBuy Legit?',
  review_desc: 'Wondering whether AllChinaBuy is legitimate, how the warehouse works or what to expect from shipping? Our independent guides explain the key considerations so you can make informed decisions.',
  review_cta: 'Read the AllChinaBuy Review →',

  // FAQ
  faq_title: 'AllChinaBuy Spreadsheet FAQ',
  faq_q1: 'What is an AllChinaBuy spreadsheet?',
  faq_a1: 'An AllChinaBuy spreadsheet is a curated collection of product links, seller information, and buying resources organized for easy reference. It helps shoppers find products efficiently.',
  faq_q2: 'How do I use an AllChinaBuy spreadsheet?',
  faq_a2: 'Simply browse the categories, click on product links to view details, and follow the buying guides to complete your purchase safely.',
  faq_q3: 'Is AllChinaBuy legit?',
  faq_a3: 'AllChinaBuy is a known shopping agent platform. Like any online service, it is important to understand the process, verify sellers, and follow safety guidelines.',
  faq_q4: 'Is AllChinaBuy safe?',
  faq_a4: 'Safety depends on following best practices: verify sellers, use QC photos, understand shipping costs upfront, and read our safety guides.',
  faq_q5: 'How much does AllChinaBuy shipping cost?',
  faq_a5: 'Shipping costs vary by destination, weight, and shipping method. Use our shipping guide to estimate costs before ordering.',
  faq_q6: 'Does AllChinaBuy have a warehouse?',
  faq_a6: 'Yes, AllChinaBuy operates warehouses where items are stored, inspected, and consolidated before international shipping.',
  faq_q7: 'Does AllChinaBuy offer coupons or discount codes?',
  faq_a7: 'Discount codes may be available periodically. Check our coupon guide for current offers and how to apply them.',
  faq_q8: 'How do I check product quality?',
  faq_a8: 'Always request QC (Quality Control) photos before shipping. Our QC guide explains exactly what to look for.',

  // Final CTA
  final_cta_title: 'Ready to Explore the AllChinaBuy Spreadsheet?',
  final_cta_desc: 'Start with the spreadsheet hub, explore popular products, compare options and learn the buying process with our latest guides.',
  final_cta_primary: 'Explore AllChinaBuy Spreadsheet',
  final_cta_secondary: 'Visit Main Website',
  final_cta_buy_now: 'Buy It Now',

  // Footer
  footer_disclaimer: 'This website is an independent informational resource. It is not the official AllChinaBuy website unless explicitly stated. Information can change, so users should verify important details directly before making purchases or payments.',
  footer_copyright: '© 2026 allchinabuyspread.cc — All rights reserved.',
  footer_links: 'Quick Links',
  footer_resources: 'Resources',
  footer_legal: 'Legal',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms of Use',
  footer_disclaimer_link: 'Disclaimer',
  footer_contact: 'Contact',
  footer_about: 'About',

  // Common
  allchinabuy_spreadsheet: 'AllChinaBuy Spreadsheet',
  read_more: 'Read More',
  learn_more: 'Learn More',
  search: 'Search',
  category: 'Category',
  product: 'Product',
  seller: 'Seller',
  price: 'Price',
  last_updated: 'Last Updated',

  // Dropdown categories
  cat_shoes: 'Shoes',
  cat_hoodies: 'Hoodies/Sweaters',
  cat_tshirts: 'T-Shirts',
  cat_jackets: 'Jackets',
  cat_pants: 'Pants/Shorts',
  cat_headwear: 'Headwear',
  cat_sets: 'Sets',
  cat_underwear: 'Underwear/Underpants',
  cat_jersey: 'Jersey',
  cat_accessories: 'Accessories',
  cat_bags: 'Bags',
  cat_belts: 'Belts',
  cat_perfumes: 'Perfumes',
  cat_other: 'Other Stuff',
};